import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { CommonTaskStatus } from '@euler/model/enum';
import { memo } from 'react';
import { TIMED_OUT, TOKENS } from '../constants';
import { StepStatus } from '../types';

export const ViewStatusLabel = memo(
  ({
    status,
    viewed,
    timedOut,
    historyMode,
  }: {
    status: StepStatus;
    viewed: boolean | null;
    timedOut?: boolean;
    historyMode?: boolean;
  }) => {
    const { rpx } = useResponsiveContext();
    const pendingColor = timedOut
      ? TIMED_OUT.viewStatusPendingText
      : TOKENS.viewStatusPendingText;
    if (status !== CommonTaskStatus.Finished) {
      return (
        <Typography.Label
          size={rpx(9)}
          lineHeight={rpx(12)}
          color={pendingColor}
        >
          {historyMode ? '无报告' : '待生成'}
        </Typography.Label>
      );
    }
    if (viewed === true) {
      return (
        <Typography.Label
          size={rpx(9)}
          lineHeight={rpx(12)}
          color={TOKENS.viewStatusReadText}
        >
          ◉ 车主已读
        </Typography.Label>
      );
    }
    return (
      <Typography.Label
        size={rpx(9)}
        lineHeight={rpx(12)}
        color={TOKENS.viewStatusUnreadText}
      >
        ⊘ 未读
      </Typography.Label>
    );
  },
);
